export const autoScheduleModalZIndex = 200
export const requirementStatsZIndex = 230
export const autoScheduleConfirmZIndex = 250
